import React from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const FormInputRadio = ({ name, control, rules, options, row = false, sx, style }) => {
  const { t } = useTranslation();

  const getColorByValue = value => {
    switch (value) {
      case 'APPROVED':
        return '#0275FC';
      case 'REFUSED':
        return '#FF3A29';
      case 'APPROVAL_PENDING':
        return '#000';
      case 'WITHDREW':
        return '#000';
      default:
        return '#000';
    }
  };

  const generateRadioOptions = () => {
    return options.map((singleOption, i) => (
      <FormControlLabel
        key={i}
        value={singleOption.value}
        label={t(singleOption.label)}
        control={<Radio sx={sx} />}
        sx={{
          '.MuiFormControlLabel-label': {
            color: getColorByValue(singleOption.value), // Set the color of the label
          },
        }}
      />
    ));
  };
  return (
    <FormControl component="fieldset">
      <Controller
        name={name}
        rules={rules}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <RadioGroup
            sx={{
              ...style,
              '& .MuiSvgIcon-root': { fill: error ? '#d32f2f' : '' },
            }}
            key={value}
            defaultValue={value}
            onChange={onChange}
            row={row}>
            {generateRadioOptions()}
          </RadioGroup>
        )}
      />
    </FormControl>
  );
};
